import { useId, type ReactNode } from "react";

interface FigureFrameProps {
  children: ReactNode;
  className?: string;
  caption?: ReactNode;
  title: string;
  description: string;
  viewBox?: string;
}

export function FigureFrame({
  children,
  className,
  caption,
  title,
  description,
  viewBox = "0 0 720 440",
}: FigureFrameProps) {
  const id = useId().replace(/:/g, "");
  const titleId = `figure-title-${id}`;
  const descriptionId = `figure-description-${id}`;

  return (
    <figure className={className} style={{ margin: 0 }}>
      <svg
        viewBox={viewBox}
        role="img"
        aria-labelledby={`${titleId} ${descriptionId}`}
        preserveAspectRatio="xMidYMid meet"
        style={{
          display: "block",
          width: "100%",
          height: "auto",
          fontFamily: "inherit",
          color: "var(--figure-ink, currentColor)",
        }}
      >
        <title id={titleId}>{title}</title>
        <desc id={descriptionId}>{description}</desc>
        {children}
      </svg>
      {caption ? (
        <figcaption className="research-figure__caption">{caption}</figcaption>
      ) : null}
    </figure>
  );
}
